import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"position":"sticky","top":"0","z-index":"2000"} }
const _hoisted_2 = { id: "goToContainer" }

import HeaderNav from "./components/HeaderNav.vue";
import TheFooter from "./components/TheFooter.vue";
import { useDisplay, DisplayInstance } from "vuetify";
import { computed, provide } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const display: DisplayInstance = useDisplay();
const router = useRouter();

provide(`displayWidth`, display.width);
provide(`store`, store);
provide(`router`, router);

const displayWidth = computed(() => {
  return display.width.value < 1000;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: _normalizeClass({ bigScreen: !displayWidth.value })
  }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createVNode(HeaderNav)
      ]),
      _createElementVNode("main", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("footer", null, [
        _createVNode(TheFooter)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})